import { twMerge } from 'tailwind-merge'

export interface UnreadIndicatorProps {
  className?: string
  iconClassName?: string
}

export default function UnreadIndicator({ className, iconClassName }: UnreadIndicatorProps) {
  return (
    <div className={twMerge('flex items-center rounded-full p-1 text-xs', className)}>
      <div className={twMerge('bg-brand-primary h-[5px] w-[5px] rounded-full', iconClassName)} />
    </div>
  )
}
